var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',{model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('vs-tab',{attrs:{"label":"FCO"}},[_c('fco',{attrs:{"fcoID":_vm.fcoID}})],1),_c('vs-tab',{attrs:{"label":"LCO"}},[_c('lco',{attrs:{"lcoID":_vm.lcoID}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }